'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var debug = require('debug');

var utils = require('../utils.js');

var errors = require('../errors.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var log = debug__default['default']('ipfs:repo:migrator:repo:init');

function isRepoInitialized(_x) {
  return _isRepoInitialized.apply(this, arguments);
}

function _isRepoInitialized() {
  _isRepoInitialized = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(backends) {
    var root, versionCheck, configCheck;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (backends) {
              _context.next = 2;
              break;
            }

            throw new errors.MissingRepoOptionsError('Please pass repo options when trying to open a repo');

          case 2:
            root = backends.root;
            _context.prev = 3;
            _context.next = 6;
            return root.open();

          case 6:
            _context.next = 8;
            return root.has(utils.VERSION_KEY);

          case 8:
            versionCheck = _context.sent;
            _context.next = 11;
            return root.has(utils.CONFIG_KEY);

          case 11:
            configCheck = _context.sent;

            if (!(!versionCheck || !configCheck)) {
              _context.next = 16;
              break;
            }

            log("Version entry present: ".concat(versionCheck));
            log("Config entry present: ".concat(configCheck));
            return _context.abrupt("return", false);

          case 16:
            return _context.abrupt("return", true);

          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](3);
            log('While checking if repo is initialized error was thrown: ' + _context.t0.message);
            return _context.abrupt("return", false);

          case 23:
            _context.prev = 23;

            if (!(root !== undefined)) {
              _context.next = 32;
              break;
            }

            _context.prev = 25;
            _context.next = 28;
            return root.close();

          case 28:
            _context.next = 32;
            break;

          case 30:
            _context.prev = 30;
            _context.t1 = _context["catch"](25);

          case 32:
            return _context.finish(23);

          case 33:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 19, 23, 33], [25, 30]]);
  }));
  return _isRepoInitialized.apply(this, arguments);
}

exports.isRepoInitialized = isRepoInitialized;